import { render, staticRenderFns } from "./AppDashTreinador.vue?vue&type=template&id=727a6c66&"
import script from "./AppDashTreinador.vue?vue&type=script&lang=js&"
export * from "./AppDashTreinador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports